import { YesObject } from '@yes.technology/react-toolkit'
import { useEffect, useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ArrayFieldValue } from '../../FilterFields/types'
import { FullSelectionOption } from '../../SelectAndLink/SelectAndLink.types'
import { isMinimalSelectionOption } from '../../SelectAndLink/utils/isMinimalSelectionOption'
import { SelectionOption } from '../types'

export const SELECTED_OBJECTS_PARAM = 'selected_objects'

export type SelectedRows = Record<string, SelectionOption>

export const parseOptionsToSelectedRows = (
  selectedOptions: ArrayFieldValue = []
): SelectedRows =>
  selectedOptions.reduce((acc: SelectedRows, option) => {
    const minimal = isMinimalSelectionOption(option)
    acc[option.uuid] = {
      uuid: option.uuid,
      des: option.des ?? '',
      value: minimal ? undefined : (option as YesObject)
    }
    return acc
  }, {})

const useSelectedRowsFromSearchParams = (): [
  SelectedRows,
  React.Dispatch<React.SetStateAction<SelectedRows>>
] => {
  const [selectedRows, setSelectedRows] = useState<SelectedRows>({})
  const [searchParams] = useSearchParams()

  const searchParamsObjectsString = searchParams.get(SELECTED_OBJECTS_PARAM)
  const searchParamsObjects: FullSelectionOption[] | undefined = useMemo(():
    | FullSelectionOption[]
    | undefined => {
    try {
      const parsed = JSON.parse(searchParamsObjectsString ?? '')
      return parsed
    } catch {
      return undefined
    }
  }, [searchParamsObjectsString])

  useEffect(() => {
    if (Array.isArray(searchParamsObjects)) {
      setSelectedRows(parseOptionsToSelectedRows(searchParamsObjects))
    }
  }, [searchParamsObjects])

  return [selectedRows, setSelectedRows]
}

export default useSelectedRowsFromSearchParams
